// Phase 1 keeps existing edits in the browser. The server accepts the resulting
// snapshot only if its original revision still matches atomically (see #759).
export function editQueue(queue, action, { itemId, position, item } = {}) {
  if (!Number.isSafeInteger(queue?.revision) || queue.revision < 0) {
    throw new Error("Reload the queue before editing.");
  }
  const state = JSON.parse(JSON.stringify(queue));
  const visible = state.items[state.visibleIndex];
  const preview = state.items[state.previewIndex];
  const pinned = [visible, preview].filter((row, index, rows) => row && rows.indexOf(row) === index);
  const upcoming = state.items.filter(row => !pinned.includes(row));
  if (action === "add") {
    if (!item?.id || state.items.some(row => row.id === item.id) ||
        state.history.some(entry => entry.item?.id === item.id)) {
      throw new Error("This item is already in the queue or history.");
    }
    upcoming.push(JSON.parse(JSON.stringify(item)));
  } else if (action === "move" || action === "remove") {
    const index = upcoming.findIndex(row => row.id === itemId);
    if (index < 0) throw new Error("This item is no longer upcoming. Review the latest queue.");
    if (action === "remove") upcoming.splice(index, 1);
    else {
      const targets = { up: Math.max(0, index - 1), down: Math.min(upcoming.length - 1, index + 1), top: 0, bottom: upcoming.length - 1 };
      if (!Object.prototype.hasOwnProperty.call(targets, position)) throw new Error("Unknown move position.");
      upcoming.splice(targets[position], 0, upcoming.splice(index, 1)[0]);
    }
  } else throw new Error("Unknown queue edit.");
  state.items = [...pinned, ...upcoming].map((row, sortOrder) => ({ ...row, sortOrder }));
  state.visibleIndex = visible ? state.items.findIndex(row => row.id === visible.id) : null;
  state.previewIndex = preview ? state.items.findIndex(row => row.id === preview.id) : null;
  return { ...state, baseRevision: queue.revision };
}
